module.exports = __webpack_public_path__ + "static/media/close.e21bdc32.svg";